import { render } from "./HomeTransactions.vue?vue&type=template&id=18df5746"
import script from "./HomeTransactions.vue?vue&type=script&lang=js"
export * from "./HomeTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__